module.exports = __webpack_public_path__ + "img/fill2.39e0ab30.svg";